export const SET_GRAPHICAL_DATA = 'Auth/SET_GRAPHICAL_DATA';

export const setGraphicalData = (data) => ({
  type: SET_GRAPHICAL_DATA,
  payload: data,
});

export const reducer = (state, action) => ({
  ...state,
  graphicalData: action.payload,
});
